/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const VEHICLE_SERIES_DEFINITION_SLICE_NAME = 'vehicleSeriesDefinition';
